(function () {
  "use strict";

  /* ------------------------------------------------------------------
     Newsletter popup — auto-open after a delay, at most once per visitor,
     never again once they've subscribed. Mirrors the storage keys used by
     the theme's original corner "newsletter-popup" pop-in so both cannot
     end up showing at the same time on a given visit.
  ------------------------------------------------------------------ */
  function shouldAppearAutomatically(modal) {
    if (localStorage.getItem("theme:popup-filled") === "true") return false;
    if (modal.hasAttribute("data-show-only-once") && localStorage.getItem("theme:popup-appeared") === "true") {
      return false;
    }
    return true;
  }

  function initNewsletterModal(modal) {
    if (window.Shopify && window.Shopify.designMode) return;
    if (!shouldAppearAutomatically(modal)) return;

    var delay = parseInt(modal.getAttribute("data-apparition-delay") || "0", 10) * 1000;

    setTimeout(function () {
      modal.show();
      localStorage.setItem("theme:popup-appeared", "true");
    }, delay);
  }

  document.querySelectorAll(".newsletter-popup-modal").forEach(function (modal) {
    customElements.whenDefined("x-modal").then(function () {
      initNewsletterModal(modal);
    });
  });
})();
